import DibsLegacyDynamic from "./dibs-legacy";

const modul = angular
    .module("PaymentRedirectComponents", [])

    .directive("dibsLegacyDynamic", DibsLegacyDynamic);

export default modul.name;
